export default __webpack_public_path__ + "static/app-development-with-swift-f21ae10cdef3a8f1b253326fffb3c584.png";